module.exports = __webpack_public_path__ + "img/666.ccc3e515.png";